<template>
  <standard-layout title="Leagues">
    <v-container fluid>
      <template v-if="allLeagues.length > 0">
        <v-list>
          <v-list-item
            v-for="league in allLeagues"
            :key="league.id"
            density="default"
            class="mb-1"
            :to="{ name: 'league', params: { id: league.id } }"
            :title="league.title"
            :subtitle="`${(league.members || []).length} player${league.members.length === 1 ? '' : 's'}`"
            prepend-icon="mdi-flag-checkered"
          />
        </v-list>

        <div class="text-center mt-4">
          <v-btn
            color="primary"
            prepend-icon="mdi-plus"
            @click="$router.push({ name: 'leagueNew' })"
          >
            Create League
          </v-btn>
        </div>
      </template>

      <div v-else class="text-center">
        <p class="text-body-1 mb-4">
          No leagues yet.
        </p>
        <v-btn
          color="primary"
          prepend-icon="mdi-plus"
          @click="$router.push({ name: 'leagueNew' })"
          >
            Create League
          </v-btn>
        </div>
    </v-container>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/components/standard-layout.vue";
import { db, dbFns } from "@/db";
import getModel from "@/models/get-model";

export default {
  components: {
    StandardLayout
  },
  inject: ["$store"],
  data () {
    return {
      allLeagues: [],
      leagueModels: {},
      membersSnapshotUnsubscribe: null
    };
  },
  created () {
    this.loadAllLeagues();
  },
  beforeUnmount () {
    if (this.membersSnapshotUnsubscribe) this.membersSnapshotUnsubscribe();
    Object.values(this.leagueModels).forEach(model => model.unsubscribe());
  },
  methods: {
    loadAllLeagues () {
      const { collection, query, where, onSnapshot } = dbFns;
      const q = query(
        collection(db, "members"),
        where("memberUserId", "==", this.$store.user.id)
      );
      this.membersSnapshotUnsubscribe = onSnapshot(q, (snapshot) => {
        const promises = [];
        snapshot.docs.forEach(d => {
          const data = d.data();
          if (this.leagueModels[data.leagueId]) return;
          const LeagueModel = getModel("league");
          const league = new LeagueModel({
            propsData: {
              docRef: dbFns.doc(db, "leagues", data.leagueId),
              user: { id: data.userId },
              parent: { id: data.userId },
              startSnapshot: true,
              docType: "league"
            }
          });
          this.leagueModels[data.leagueId] = league;
          promises.push(Promise.all([league.promiseOnSnapshot, ...league.prereqPromises]));
        });
        Promise.all(promises).then(() => {
          this.allLeagues = Object.values(this.leagueModels)
            .slice()
            .sort((a, b) => (b.createdAt?.toDate?.() ?? 0) - (a.createdAt?.toDate?.() ?? 0));
        }).catch((error) => {
          console.error({ error });
        });
      }, (error) => {
        console.error({ error });
      });
    }
  }
};
</script>
